import {jarallax} from "jarallax";

export default (el) => {
  jarallax(document.querySelectorAll('.jarallax-providing'), {
    speed: 0.2,
  });
}
